import ReactDOM from "react-dom/client";
import { ParallaxProvider } from "react-scroll-parallax";
import "./index.css";
import "./i18n";
import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
  <ParallaxProvider>
    <App />
  </ParallaxProvider>,
);

reportWebVitals();
